<template>
  <div class="store-tag-page">
    <NavHeaderBar :showSearch="false" navBarTitle="Store Tag Determination">
    </NavHeaderBar>
    <div class="store-tag-content">
      <div class="store-tag-before">
        <!-- 活动前 -->
        <div>{{ paramUrl.pageType === 'storeMaintain' ? $t('shared.current') : $t('shared.preEvent') }} {{ $t('form.storeTag') }}：</div>
        <div class="tag-info" :class="beforeCustomerTag | formatTagClass">{{ beforeCustomerTag | formatTag }}</div>
      </div>
      <div class="store-tag-after">
        <!-- 根据此次event开展情况，将StoreTag设为 | 根据门店日常运营情况，将StoreTag设为 -->
        <div class="after-title">{{ paramUrl.pageType === 'storeMaintain' ? $t('tips.messageThirtyEight') : $t('tips.messageThirtyNine') }}：</div>
        <XuSelect v-model="afterCustomerTag" :dataOptions="tagList" />
      </div>
    </div>
    <div class="oper-bottom-btn">
      <van-button class="right-btn" @click="handleSubmit">{{ $t('button.confirm') }}</van-button>
    </div>
  </div>
</template>

<script>
import { arsEventInfoApi } from '@/api/event'
import { setCustomerTagApi } from '@/api/shared'
import { Toast } from 'vant'
import i18n from '@/i18n'
export default {
  components: {
    XuSelect: () => import('@/components/XuSelect')
  },
  filters: {
    formatTag (value) {
      return value === 0 ? i18n.t('shared.filter.toBeVerified') : value === 1 ? i18n.t('shared.filter.sVIPCore') : value === 2 ? i18n.t('shared.filter.vIPCore') : value === 3 ? i18n.t('shared.filter.potential') : ''
    },
    formatTagClass (value) {
      return `tag${value}`
    }
  },
  data () {
    return {
      eventInfo: {},
      tagList: [
        { label: this.$t('shared.filter.sVIPCore'), value: 1 },
        { label: this.$t('shared.filter.vIPCore'), value: 2 },
        { label: this.$t('shared.filter.potential'), value: 3 }
      ],
      afterCustomerTag: '',
      navTitle: this.$t('button.storeTagDetermination'),
      paramUrl: '',
      beforeCustomerTag: ''
    }
  },
  activated () {
    const { pageType } = this.$route.query
    this.paramUrl = this.$route.query
    this.afterCustomerTag = ''
    this.beforeCustomerTag = this.paramUrl.customerTag ? Number(this.paramUrl.customerTag) : ''
    if (pageType === 'storeMaintain') {
      this.navTitle = this.$t('shared.storeTagChange')
    } else {
      this.navTitle = this.$t('button.storeTagDetermination')
      this.getEventInfo()
    }
  },
  methods: {
    getEventInfo () {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      arsEventInfoApi(this.$route.query.eventId).then(res => {
        Toast.clear()
        this.eventInfo = res.data
        this.beforeCustomerTag = res.data.beforeCustomerTag
      })
    },
    handleSubmit () {
      if (!this.afterCustomerTag) {
        Toast(this.$t('tips.storeTagIsRequired'))
        return
      }
      const data = {
        customerTag: this.afterCustomerTag
      }
      if (this.paramUrl.pageType === 'storeMaintain') {
        data.visitId = this.$route.query.visitId
        data.customerId = this.$route.query.customerId
      } else {
        data.eventId = this.$route.query.eventId
      }
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      setCustomerTagApi(data).then(res => {
        Toast.clear()
        this.$router.go(-1)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.store-tag-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  .store-tag-content {
    flex: 1;
    padding: 20px;
    overflow-y: auto;
    .store-tag-before {
      display: flex;
      align-items: center;
      .tag-info {
        padding: 3px 5px;
        text-align: center;
        font-size: 10px;
        border: 1px solid #ee541b;
        color: #ee541b;
        background-color: #eccfc4;
        margin-right: 6px;
        line-height: 13px;
      }
      .tag0 {
        border: 1px solid #0db00b;
        color: #0db00b;
        background-color: #abdaaa;
      }
      .tag2 {
        border: 1px solid #dc851f;
        color: #dc851f;
        background-color: #f0e2d1;
      }
      .tag3 {
        border: 1px solid #7f7f7f;
        color: #7f7f7f;
        background-color: #dcdcdc;
      }
    }
    .store-tag-after {
      margin-top: 16px;
      .after-title {
        margin-bottom: 10px;
      }
    }
  }
}
</style>
